const getItemPosition = (page, pageSize, position) => {
    if (Boolean(page) && Boolean(pageSize)) {
        return (page - 1) * pageSize + (position + 1);
    } else {
        return position;
    }
};

export default getItemPosition;
